import Inputmask from "inputmask"
import { observer } from "mobx-react"
import React, { useEffect, useState } from "react"
import { DataLayerFn } from "../../Configs/API"
import FormStore from "../../Configs/Store/forms"
import AppStore from "../../Configs/Store/index"
import ModalStore from "../../Configs/Store/modals"
import CircleIcon from "../Common/CircleIcon"
import CloseButton from "../Common/CloseButton"
import { scrollPatch } from "../Common/CommonFunctions"
import GenericModal from "../Common/GenericModal"
import CommonStore from "../../Configs/Store/common"

const InvestModal = observer(({ component, calcFormRef }) => {
  const [togCalc, setTogCalc] = useState(false)
  
  useEffect(() => {
    ModalStore.invest_calc_quote && FormStore.setQuoteModal(true)
  }, [])

  useEffect(() => {
    if (ModalStore.invest_calc_quote) {
      setTogCalc(true)
      // FormStore.setQuoteModalLoader(true)
      setTimeout(() => {
        var selector = document.getElementsByClassName("js-dobInput")[1]
        if (selector !== null) {
          Inputmask("99/99/9999", {
            placeholder: "DD/MM/YYYY",
            prefillYear: false,
          }).mask(selector)
        }
      }, 1000)
    } else {
      setTimeout(() => {
        setTogCalc(false)
      }, 100)
    }
  }, [ModalStore.invest_calc_quote])

  const handleOnOkClick = async () => {
    await calcFormRef.submit()
    scrollPatch("hidden")
    DataLayerFn("InvestNow_submit||Calculator-QuoteScreen|InvestNow", FormStore, "", "", CommonStore.recommendedSelectedPlan, { QuoteFlag: true })
  }

  const handleClose = () => {
    FormStore.setQuoteModal(false)
    ModalStore.setInvestCalcQuote(false)
    scrollPatch("auto")
    DataLayerFn("InvestNow_PopupClose||Calculator-QuoteScreen|InvestNow", FormStore, "", "", CommonStore.recommendedSelectedPlan, "")
  }

  const handleVisiblity = () => {
    FormStore.setQuoteModal(false)
    ModalStore.setInvestCalcQuote(false)
    scrollPatch("auto")
  }

  return (
    <GenericModal
      visibleState={togCalc}
      updateVisibility={handleVisiblity}
      rootClassAntCustom={"InvestModal"}
      zIndex={ModalStore.invest_calc_quote && togCalc ? 3000 : -1}
      closeIcon={
        AppStore.device === 0 ? (
          <CircleIcon iconUrl={`assets/common/Path15589.svg`} iconStyle="closeIconModalMob" onClick={handleClose} />
        ) : (
          <div className="PCModalTextCrossWrapper">
            <CloseButton className="closeIconModalPC" onClick={handleClose} />
          </div>
        )
      }
      showButton={true}
      buttonText={"Submit"}
      buttononClick={handleOnOkClick}
      component={component}
    />
  )
})

export default InvestModal
